import React, {useState} from "react";
import {isMobile} from "../../../../helpers/Mobile"
import styles from "./MainApp.organisms.EditPanel.module.scss";
import i18n from "i18n";


export const EditPanel = ({fields, title=i18n.t("description"), handleEdit}) => {
    // const [ toggleOpen, setToggleOpen ] = useState(false)

    return (
        <div className={styles["edit-panel-container"]}>

            <div className={styles["edit-panel-title"]}>
            {title}
            <i name="icon-iconos_editar" className={`icon-iconos_editar ${styles["edit-panel-icon"]}`} onClick={handleEdit}></i>
            </div>

                {<React.Fragment>
                    {fields.map( item => {
                        return (<div className={styles["edit-panel-section"]} key={item.title}>
                                    <div className={styles["edit-panel-section-title"]}>{item.title}</div>
                                    <div className={styles["edit-panel-section-content"]}>{item.value}</div>
                                </div>)
                    })}
                </React.Fragment>}

        </div>
    );

}

export default EditPanel;